import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import HSGNavigation from './Component/HSGNavigation';

const mapStateToProps = (state, ownProps) => ({
    user: state.auth.userProfile,

    childList: state.child.childList || [],
    childCurrent: state.child.selectedChild || 0,

    currentAppLocation: state.metaData.currentAppLocation,

});

const mapDispatchToProps = (dispatch) => ({
      logoutUser: () => dispatch(Actions.logoutUser()), // Action to logout
      changeLocation: (location) => dispatch(Actions.changeCurrentLocation(location)),
      unsetSidebarHandler: (sideBarState) => dispatch(Actions.unsetSidebar(sideBarState))


})

export default connect(mapStateToProps, mapDispatchToProps)(HSGNavigation)

